var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "post",
      style: { width: _vm.resolution + "px" },
      attrs: { id: "viewport-for-capture" },
    },
    [
      _c(
        "Phone",
        { attrs: { showNotch: true } },
        [
          _vm.formData && _vm.pageIdSelected && _vm.pages[_vm.pageIdSelected]
            ? _c("renderPostManager", {
                attrs: {
                  typeNetworkSelected: _vm.pages[_vm.pageIdSelected].network,
                  formData: _vm.formData,
                  files: _vm.files,
                  pages: [_vm.pages[_vm.pageIdSelected]],
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }